<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Informações da Sala</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="title">
                            <span class="required">*</span> Titulo:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="rooms.title"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="roomCompany">
                            <span class="required">*</span> Empresa
                          </label>
                          <select
                            v-model="rooms.company_id"
                            disabled
                            class="form-control"
                          >
                            <option
                              v-for="company in companies"
                              :value="company.id"
                              :key="company.id"
                            >
                              {{ company.company_name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="tag">
                            <span class="required">*</span> Tag:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="rooms.tag"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="branch_id">
                            <span class="required">*</span> Filial/Prédio:
                          </label>
                          <select
                            v-model="rooms.branch_id"
                            disabled
                            class="form-control"
                          >
                            <option
                              v-for="branch in branches"
                              :value="branch.id"
                              :key="branch.id"
                            >
                              {{ branch.title }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="number_room">
                            <span class="required">*</span> Nº da Sala:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="rooms.number_room"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="floor">
                            <span class="required">*</span> Andar:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            placeholder=""
                            v-model="rooms.floor"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="capacity">
                            <span class="required">*</span> Capacidade:
                          </label>
                          <input
                            disabled
                            type="number"
                            class="form-control"
                            v-model="rooms.capacity"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Gerenciar Bloqueios da Sala de Reunião
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="alert alert-info" role="alert">
                    Ao gerar um bloqueio esta sala não ficará disponível para
                    reservas no período informado. Para gerar um bloqueio de
                    período, selecione a data e hora de início e a data e hora
                    de fim e clique em <strong>Gerar Bloqueio</strong>.
                    <br /><br />
                    <strong
                      >Observação: Reservas efetuadas ANTES da criação do
                      bloqueio, não serão canceladas automaticamente. Favor
                      entre em contato com o responsável e alinhe o cancelamento
                      manual.</strong
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row justify-content-center">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputPlace">Data Início</label>
                        <VueCtkDateTimePicker
                          minute-interval="30"
                          color="#4b2e8f"
                          button-now-translation="Hoje"
                          button-color="#4b2e8f"
                          :format="'YYYY-MM-DD HH:mm'"
                          no-label
                          label="Selecione..."
                          v-model="lock.date_start"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputPlace">Data Final</label>
                        <VueCtkDateTimePicker
                          minute-interval="30"
                          color="#4b2e8f"
                          button-now-translation="Hoje"
                          button-color="#4b2e8f"
                          :format="'YYYY-MM-DD HH:mm'"
                          no-label
                          label="Selecione..."
                          v-model="lock.date_end"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button class="btn btn-add" @click="lockRoom">
                        Gerar Bloqueio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Bloqueios Cadastrados</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="alert alert-info" role="alert">
                    Aqui você visualiza os bloqueios já cadastrados, você poderá
                    excluí-los e assim tornar automaticamente disponível para
                    reservas.
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row justify-content-center">
                    <div class="col-md-12">
                      <table class="table" style="font-size: 14px">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Data Inicio</th>
                            <th scope="col">Data Fim</th>
                            <th scope="col">Criado por</th>

                            <th scope="col">Ação</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="lock in rooms.lock" :key="lock.id">
                            <td>{{ lock.id }}</td>
                            <td>{{ lock.date_start }}</td>
                            <td>{{ lock.date_end }}</td>
                            <td>{{ lock.user.name }}</td>
                            <td>
                              <button
                                class="btn btn-add"
                                @click="deleteLockRoom(lock.id)"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="rooms.lock.length == 0">
                            <td colspan="8" align="center">
                              Nenhum registro encontrado.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQrcode from "vue-qrcode";
export default {
  data() {
    return {
      rooms: {},
      lock: {},
      branches: [],
      companies: [],
    };
  },
  methods: {
    getRooms: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api + "rooms/" + id + "/?with[]=details&with[]=lock";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data[0];
          self.rooms.details.forEach((detail, index) => {
            self.checkeds.push(detail.detail_id);
          });
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    lockRoom: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "room_locks/";

      self.lock.room_id = id;

      self.$http
        .post(api, self.lock)
        .then((response) => {
          self.getRooms();
          self.$message("Sucesso", `Bloqueio criado com sucesso`, "success");
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    deleteLockRoom: function (id) {
      let self = this;
      let api = self.$store.state.api + "room_locks/" + id;

      self.$http
        .delete(api)
        .then((response) => {
          self.getRooms();
          self.$message("Sucesso", `Bloqueio removido com sucesso`, "success");
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getRooms(id);
    }
    self.getCompanies();
    self.getBranches();
  },
  components: { VueQrcode },
};
</script>

<style scoped>
.photo-qrcode {
  width: 200px;
  height: 200px;
  text-shadow: white 0px 0px 2px;
  font-size: 16px;
  background-size: 150px;
}

.photo-sala {
  max-height: 700px;
  height: 600px;
  text-shadow: white 0px 0px 2px;
  font-size: 16px;
  background-size: 150px;
}

.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.preview {
  display: inline-block;
  border-radius: 20px;
  max-width: 200px;
  max-height: 100px;
  object-fit: cover;
}
.inlinee {
  display: inline-block;
}

.lg-check {
  margin: 20px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Rooms/Lock.vue